import styled from "styled-components";
import Link from "components/elements/ScrollToTopLink";

export const NoWrapScrollLink = styled(Link)`
  display: flex;
  align-items: center;
  white-space: nowrap;
  cursor: pointer;
`;
